import { useLang } from 'hooks/lang';

import { recruitmentStatusConfig } from 'entities';

import { Button } from 'components/Blocks';
import { UserPlusIcon } from 'components/Icons';

import { useRecruitmentModal } from './context';
import { useRecruitmentOwnerChange } from 'pages/Recruitment/hooks';
import { cn, resolveColorClass } from 'styles';

export function AssignButton() {
  const { recruitment, updateRecruitment, permissions } = useRecruitmentModal();

  const { t } = useLang();

  const { changeRecruitmentOwner } = useRecruitmentOwnerChange({
    recruitment: recruitment!,

    onNewOwner: (owner) =>
      updateRecruitment((old) => ({
        ...old,
        owner,
      })),
  });

  if (recruitment?.status !== recruitmentStatusConfig.unassigned.code || !permissions.canAssign)
    return null;

  return (
    <Button
      variant="outlined"
      onClick={changeRecruitmentOwner}
      size="small"
      className={cn(
        resolveColorClass(recruitmentStatusConfig.unassigned.color, 'text'),
        resolveColorClass(recruitmentStatusConfig.unassigned.color, 'border'),
        'h-auto rounded-sm py-1 text-xs capitalize',
      )}
    >
      <UserPlusIcon size={14} />
      {t('assign')}
    </Button>
  );
}
